import React from 'react';
import { AvatarWrapper } from './style';

function Avatar({
  imgLoaded,
  img,
  defaultValue,
  order,
  group,
  badge,
  showBadge,
  border,
  colorWithBadge,
  color,
  onClick,
  size,
}) {
  return (
    <AvatarWrapper
      onClick={onClick}
      border={border}
      showBadge={showBadge}
      group={group}
      zIndex={5 + order}
      colorWithBadge={colorWithBadge}
      color={color}
      withBg={defaultValue}
      size={size}
      imgLoaded={imgLoaded}
      img={img}
    >
      {showBadge && badge}
      {defaultValue || <span />}
    </AvatarWrapper>
  );
}

export default Avatar;
